<template>
    <div id="home">
        <div class="ribbon"></div>
        <div class="pad-top">
            <v-card class="mx-auto"
                    max-width="500">
                <v-card-title class="justify-center">Réinitialisation du mot de passe</v-card-title>

                <v-container v-if="existToken">
                    <v-text-field v-model="password"
                                  label="Mot de passe"
                                  class="mb-2"
                                  hide-details
                                  :append-icon="displayPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="displayPassword ? 'text' : 'password'"
                                  @click:append="displayPassword = !displayPassword"
                                  outlined>
                    </v-text-field>

                    <v-text-field v-model="confirmPassword"
                                  label="Confirmation du mot de passe"
                                  class="mb-2"
                                  hide-details
                                  :append-icon="displayConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="displayConfirmPassword ? 'text' : 'password'"
                                  @click:append="displayConfirmPassword = !displayConfirmPassword"
                                  outlined>
                    </v-text-field>

                    <div class="mt-5 mb-5 valid-button">
                        <div class="mt-3">
                            <p>Le mot de passe doit respecter au moins 4 règles : </p>

                            <div>
                                <v-icon color="success" class="mr-2" v-if="hasEnoughCharacters">check_circle_outline</v-icon>
                                <v-icon color="error" class="mr-2" v-else>highlight_off</v-icon>

                                <span>au moins 7 caractères</span>
                            </div>
                            <div>
                                <v-icon color="success" class="mr-2" v-if="hasAtLeastOneLowerCase">check_circle_outline</v-icon>
                                <v-icon color="error" class="mr-2" v-else>highlight_off</v-icon>

                                <span>au moins 1 miniuscule</span>
                            </div>
                            <div>
                                <v-icon color="success" class="mr-2" v-if="hasAtLeastOneUpperCase">check_circle_outline</v-icon>
                                <v-icon color="error" class="mr-2" v-else>highlight_off</v-icon>

                                <span>au moins 1 majuscule</span>
                            </div>
                            <div>
                                <v-icon color="success" class="mr-2" v-if="hasAtLeastOneDigit">check_circle_outline</v-icon>
                                <v-icon color="error" class="mr-2" v-else>highlight_off</v-icon>

                                <span>au moins 1 chiffre</span>
                            </div>
                            <div>
                                <v-icon color="success" class="mr-2" v-if="hasAtLeastOneSpecialCharacter">check_circle_outline</v-icon>
                                <v-icon color="error" class="mr-2" v-else>highlight_off</v-icon>

                                <span>au moins 1 caractère spécial</span>
                            </div>
                        </div>
                    </div>

                    <v-alert color="error" type="error" v-if="password !== confirmPassword">
                        Le mot de passe et la confirmation du mot de passe ne sont pas identiques.
                    </v-alert>

                    <div class="text-center mb-2">
                        <v-btn class="default-button" :disabled="!areRulesValid || password !== confirmPassword" @click="resetPassword">
                            Réinitialiser
                        </v-btn>
                    </div>
                </v-container>

                <v-container v-if="!existToken">
                    <v-alert color="error" type="error" >
                        Le lien de réinitialisation n'existe plus.
                    </v-alert>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "ResetPassword",
    data() {
        return {
            token: null,
            password: "",
            confirmPassword: "",
            displayPassword: false,
            displayConfirmPassword: false,
            reset: false,
            existToken: true
        }
    },
    methods: {
        checkValidToken() {
            this.$global.loading = true

            this.$http.get('auth/forget-password/check-token/' + this.token).then(res => {
                this.existToken = res.body.data.exist

                this.$global.loading = false
            })
        },
        resetPassword() {
            let payload = {
                token: this.token,
                password: this.password
            }

            this.$global.loading = true

            this.$http.post('auth/forget-password/reset', payload).then(res => {
                this.$global.loading = false

                if(res.body.success) {
                    this.$router.push({path: '/login', query: {resetPassword: 'true'}})
                }
            })
        }
    },
    computed: {
        hasEnoughCharacters() {
            return this.password.length >= 7
        },
        hasAtLeastOneLowerCase() {
            return /(?=.*[a-z])/.test(this.password)
        },
        hasAtLeastOneUpperCase() {
            return /(?=.*[A-Z])/.test(this.password)
        },
        hasAtLeastOneDigit() {
            return /(?=.*\d)/.test(this.password)
        },
        hasAtLeastOneSpecialCharacter() {
            return /(?=.*[-+_!@#$%^&*.,?])/.test(this.password)
        },
        areRulesValid() {
            return this.hasEnoughCharacters + this.hasAtLeastOneLowerCase + this.hasAtLeastOneUpperCase +
                this.hasAtLeastOneDigit + this.hasAtLeastOneSpecialCharacter >= 4
        }
    },
    created() {
        this.token = this.$route.params.token

        this.checkValidToken()
    }
}
</script>